import { useState, useCallback } from 'react'
import { Recipe } from '@pollination-solutions/pollination-sdk'
import { DetailReference, DetailContext, DetailType } from '~/types/state'

export const useDetailContext = (recipe: Recipe): DetailContext => {
  const [[nodeRef, cardRef], setActiveReference] = useState<
    [DetailReference<DetailType> | undefined, DetailReference<DetailType> | undefined]
  >([undefined, undefined])

  const setNodeReference = useCallback((ref: DetailReference<DetailType> | undefined) => {
    setActiveReference(([, card]) => [ref, card])
  }, [])

  const setCardReference = useCallback((ref: DetailReference<DetailType> | undefined) => {
    setActiveReference(([node]) => [node, ref])
  }, [])

  const reference = [nodeRef, cardRef].find((r) => r !== undefined)

  return { recipe, reference, setNodeReference, setCardReference }
}
